export default "__VITE_ASSET__e6d482b4__"